
import { calculateCartDelivery } from '@/utils/deliveryFeeGrouping';

export default {
  isInCart: state => itemId => {
    return state.cartItems.some((item) => item._id == itemId);
  },
  totalItemQuantityIncart: state => itemId => {
    const result = state.cartItems.find((item) => item.productStoreId == itemId);
    return typeof result !== 'undefined' ? result.quantity : 0;
  },
  isInWishList: state => itemId => {
    return state.wishList.some((item) => item._id == itemId);
  },
  getCartItem: state => itemId => {
    const result = state.cartItems.filter((item) => item._id == itemId);
    return result.length ? result.pop() : [];
  },
  totalCarPrice: state => {
    let total = 0;
    state.cartItems.forEach(function (value) {
      total += value.price * value.quantity;
    });
    return total;
  },
  subTotalCartPrice: state => {
    let total = 0;
    state.cartItems.forEach(function (value) {
      if (value.retoolTotalDiscount) {
        total += (value.price * value.quantity) - value.retoolTotalDiscount;
      } else {
        total += value.price * value.quantity;
      }
    });
    return total;
  },
  items: state => {
    return state.cartItems;
  },
  delivery: state => {
    return calculateCartDelivery(state.cartItems);
  },
  isInCartTest: (state) => (itemId) => {
    return state.cartItems.some((item) => item.productStoreId == itemId);
  },
  getCartItemTest: (state) => (itemId) => {
    const result = state.cartItems.filter(
      (item) => item.productStoreId == itemId
    );
    return result.length ? result.pop() : [];
  },
};
